module.exports = __webpack_public_path__ + "files/ed41abf06beb5ed10d4081b5166707c3.png";